import {
  ICheckboxFilterData,
  IFilter,
  IRadioFilterData,
  IRangeFilterData,
  ISelectOption,
  TFilterType,
  TSelectorData,
} from "../components";
import deepClone from "../helpers/deepClone";

export const brandFilterData: ICheckboxFilterData = {
  categoryName: "Brand",
  name: "brand",
  type: "checkbox",
  searchEnabled: true,
  expanded: true,
  labels: {
    noResultsMessage:
      "No results found. Maybe rephrase your search for better results?",
  },
  items: [
    {
      id: "cb0",
      title: "Adidas",
      itemsCount: 25,
      checked: false,
    },
    {
      id: "cb1",
      title: "Alpina",
      itemsCount: 36,
      checked: false,
    },
    {
      id: "cb2",
      title: "Arena",
      itemsCount: 17,
      checked: false,
    },
    {
      id: "cb3",
      title: "Asics",
      itemsCount: 76,
      checked: false,
    },
    {
      id: "cb4",
      title: "Atomic",
      itemsCount: 42,
      checked: false,
    },
    {
      id: "cb5",
      title: "Black Diamond",
      itemsCount: 18,
      checked: false,
    },
    {
      id: "cb6",
      title: "New Balance",
      itemsCount: 30,
      checked: false,
    },
    {
      id: "cb7",
      title: "Nike",
      itemsCount: 98,
      checked: true,
    },
  ],
};

export const sportFilterData: ICheckboxFilterData = {
  categoryName: "Sport",
  name: "sport",
  expanded: true,
  type: "checkbox",
  items: [
    {
      id: "cb30",
      title: "Running",
      itemsCount: 25,
      checked: false,
    },
    {
      id: "cb31",
      title: "Walking/Nordic Walking",
      itemsCount: 71,
      checked: false,
    },
    {
      id: "cb32",
      title: "Orienteering",
      itemsCount: 16,
      checked: false,
    },
    {
      id: "cb33",
      title: "Football",
      itemsCount: 76,
      checked: false,
    },
    {
      id: "cb34",
      title: "Outdoors",
      itemsCount: 42,
      checked: false,
    },
    {
      id: "cb35",
      title: "Cycling",
      itemsCount: 18,
      checked: false,
    },
    {
      id: "cb36",
      title: "Water Sports",
      itemsCount: 30,
      checked: false,
    },
    {
      id: "cb37",
      title: "Baseball",
      itemsCount: 98,
      checked: false,
    },
  ],
};

export const genderFilterData: ICheckboxFilterData = {
  categoryName: "Gender",
  name: "gender",
  type: "checkbox",
  expanded: true,
  items: [
    {
      id: "cb20",
      title: "Men",
      itemsCount: 192,
      checked: false,
    },
    {
      id: "cb21",
      title: "Women",
      itemsCount: 156,
      checked: false,
    },
    {
      id: "cb22",
      title: "Kids",
      itemsCount: 23,
      checked: false,
    },
  ],
};

export const mockSelectOptions: ISelectOption[] = [
  {
    id: "1",
    label: "Option 1",
  },
  {
    id: "2",
    label: "Option 2",
  },
  {
    id: "3",
    label: "Option 3",
  },
  {
    id: "4",
    label: "Option 4",
  },
  {
    id: "5",
    label: "Option 5",
  },
];

export const sizePickerData: TSelectorData = {
  title: "Select Your Size",
  mobileTitle: "Select a size",
  noItemsText: "No sizes available",
  items: [
    {
      id: "1",
      title: "XXS",
      subtitle: "Only 3 Items Left",
      available: true,
      icon: "warning",
    },
    { id: "2", title: "XS", subtitle: "", available: true },
    { id: "3", title: "S", subtitle: "", available: true },
    {
      id: "4",
      title: "M",
      subtitle: "Available in Store",
      available: true,
      icon: "store",
    },
    { id: "5", title: "L", subtitle: "Coming soon", available: true },
    { id: "6", title: "XL", subtitle: "Sold Out", available: false },
  ],
};

export const sizesFilterData: ICheckboxFilterData = {
  categoryName: "Size",
  name: "size",
  type: "tile",
  expanded: true,
  items: [
    {
      id: "cb8",
      title: "38",
      itemsCount: 22,
      checked: false,
    },
    {
      id: "cb9",
      title: "38.5",
      itemsCount: 15,
      checked: false,
    },
    {
      id: "cb10",
      title: "158-123",
      itemsCount: 35,
      checked: false,
    },
    {
      id: "cb11",
      title: "39.5",
      itemsCount: 41,
      checked: false,
    },
    {
      id: "cb12",
      title: "40",
      itemsCount: 12,
      checked: false,
    },
    {
      id: "cb13",
      title: "41",
      itemsCount: 19,
      checked: false,
    },
    {
      id: "cb14",
      title: "41.5",
      itemsCount: 22,
      checked: false,
    },
    {
      id: "cb15",
      title: "42",
      itemsCount: 35,
      checked: false,
    },
    {
      id: "cb16",
      title: "43",
      itemsCount: 14,
      checked: false,
    },
    {
      id: "cb17",
      title: "43.5",
      itemsCount: 10,
      checked: false,
    },
  ],
};

export const PDPSizesFilterData: ICheckboxFilterData = {
  categoryName: "Size",
  name: "size",
  type: "tile",
  expanded: true,
  items: [
    {
      id: "cb81",
      title: "36",
    },
    {
      id: "cb92",
      title: "37",
    },
    {
      id: "cb103",
      title: "38",
    },
    {
      id: "cb114",
      title: "39",
    },
    {
      id: "cb125",
      title: "39,5",
    },
    {
      id: "cb136",
      title: "40",
    },
    {
      id: "cb147",
      title: "41",
    },
    {
      id: "cb158",
      title: "41,5",
    },
    {
      id: "cb169",
      title: "42",
    },
    {
      id: "cb1710",
      title: "42.5",
      unavailable: true,
    },
    {
      id: "cb1711",
      title: "43",
      unavailable: true,
    },
    {
      id: "cb1712",
      title: "43.5",
      unavailable: true,
    },
  ],
};

export const priceFilterData: IRangeFilterData = {
  categoryName: "Price",
  titles: {
    min: "Min",
    max: "Max",
  },
  name: "price",
  type: "range",
  currency: "€",
  expanded: false,
  min: "0",
  max: "400",
  defaultValue: ["0", "200"],
  value: ["5", "205"],
};

export const sortFilterData: IRadioFilterData = {
  categoryName: "Sort by",
  name: "sort",
  type: "radio",
  expanded: true,
  isSorting: true,
  /** will not be shown in chips when this value is active */
  defaultValue: "1",
  items: [
    { id: "rb0", value: "1", title: "Most Popular", checked: true },
    { id: "rb1", value: "2", title: "Newest", checked: false },
    { id: "rb2", value: "3", title: "Price: Low to High", checked: false },
    { id: "rb3", value: "4", title: "Price: High to Low", checked: false },
    {
      header: "Road Bikes",
      id: "rb4",
      value: "5",
      title: "Weight: Light To Heavy",
      checked: false,
    },
    {
      id: "rb5",
      value: "6",
      title: "Number of gears: Many to Few",
      checked: false,
    },
    {
      id: "rb6",
      value: "7",
      title: "Number of gears: Few to Many",
      checked: false,
    },
  ],
};

export const radioGroupExtendedMock: IRadioFilterData = {
  categoryName: "Sports",
  name: "radioGroupExtendedMock",
  type: "radio",
  expanded: true,
  /** will not be shown in chips when this value is active */
  defaultValue: "1",
  labels: {
    noResultsMessage:
      "No results found. Maybe rephrase your search for better results?",
  },
  items: [
    { id: "rb0", value: "1", title: "Actionsport", checked: false },
    { id: "rb1", value: "2", title: "Alpint", checked: false },
    { id: "rb2", value: "3", title: "Badminton", checked: false },
    { id: "rb3", value: "4", title: "Bandy", checked: false },
    { id: "rb4", value: "5", title: "Basket", checked: false },
    { id: "rb5", value: "6", title: "Bordtennis", checked: false },
    { id: "rb6", value: "7", title: "Cykel", checked: false },
    { id: "rb7", value: "8", title: "Soccer", checked: false },
    { id: "rb8", value: "9", title: "Golf", checked: false },
    { id: "rb9", value: "10", title: "Handball", checked: false },
    { id: "rb10", value: "11", title: "Hockey", checked: false },
  ],
};

export const timeSlotData: IRadioFilterData = {
  categoryName: "Sort by",
  name: "sort",
  type: "radio",
  expanded: true,
  defaultValue: "1",
  items: [
    { id: "tb0", value: "1", title: "09:00-12:00", checked: true },
    { id: "tb1", value: "2", title: "12:00-15:00", checked: false },
    { id: "tb2", value: "3", title: "15:00-18:00", checked: false },
    { id: "tb3", value: "4", title: "18:00-21:00", checked: false },
  ],
};

export const categoryFilterData: ICheckboxFilterData = {
  categoryName: "Category",
  name: "categories",
  type: "checkbox",
  items: [],
};

export const colorFilterData: ICheckboxFilterData = {
  categoryName: "Color",
  name: "Color",
  type: "tile",
  expanded: true,
  items: [
    {
      id: "cb61",
      itemsCount: 22,
      color: "multicolor",
      title: "Multicolor",
    },
    {
      id: "cb71",
      itemsCount: 22,
      color: "transparent",
      title: "Transparent",
    },
    {
      id: "cb81",
      itemsCount: 22,
      color: "black",
      title: "Black",
    },
    {
      id: "cb91",
      color: "blue",
      itemsCount: 15,
      title: "Blue",
    },
    {
      id: "cb101",
      color: "brown",
      itemsCount: 35,
      title: "Brown",
    },
    {
      id: "cb111",
      color: "gold",
      itemsCount: 41,
      title: "Gold",
    },
    {
      id: "cb121",
      color: "green",
      itemsCount: 12,
      title: "Green",
    },
    {
      id: "cb131",
      color: "grey",
      itemsCount: 19,
      title: "Grey",
    },
    {
      id: "cb141",
      color: "orange",
      itemsCount: 22,
      title: "Orange",
    },
    {
      id: "cb151",
      color: "pink",
      itemsCount: 35,
      title: "Pink",
    },
    {
      id: "cb161",
      color: "purple",
      itemsCount: 14,
      title: "Purple",
    },
    {
      id: "cb171",
      color: "red",
      itemsCount: 10,
      title: "Red",
    },
    {
      id: "cb172",
      color: "silver",
      itemsCount: 10,
      title: "Silver",
    },
    {
      id: "cb173",
      color: "white",
      itemsCount: 10,
      title: "White",
    },
  ],
};

export const materialFilterData: ICheckboxFilterData = {
  categoryName: "Material",
  name: "material",
  type: "checkbox",
  items: [],
};

export const mobileFilterItems: IFilter<TFilterType>[] = [
  sortFilterData,
  genderFilterData,
  categoryFilterData,
  sportFilterData,
  brandFilterData,
  sizesFilterData,
  colorFilterData,
  priceFilterData,
  materialFilterData,
];

export const desktopFilterItems: IFilter<TFilterType>[] = [
  genderFilterData,
  categoryFilterData,
  sportFilterData,
  brandFilterData,
  sizesFilterData,
  colorFilterData,
  priceFilterData,
  materialFilterData,
];

export const desktopTopFilterItems: IFilter<TFilterType>[] = [
  genderFilterData,
  sportFilterData,
  brandFilterData,
  sizesFilterData,
  colorFilterData,
  priceFilterData,
];

export const desktopTopFilterItemsCheckedGender = deepClone(
  desktopTopFilterItems,
);

/** !!! Mutation !!! */
(desktopTopFilterItemsCheckedGender[0] as ICheckboxFilterData).items = (
  desktopTopFilterItemsCheckedGender[0] as ICheckboxFilterData
).items.map((item) => ({
  ...item,
  checked: true,
}));
